export default __webpack_public_path__ + "static/media/Bajaj3.90262b0c.jpg";